module.exports = __webpack_public_path__ + "img/lf8.57017f8b.png";